/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import {I18n} from 'react-redux-i18n';
import PropTypes from 'prop-types';

import {map, get} from 'lodash';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  CircularProgress,
  Typography,
  Button,
  Icon,
  Grid
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import OerCheckBox from '../../components/OerCheckbox';

export default class EventVideoAlerts extends React.Component {

  static propTypes = {
    user: PropTypes.object.isRequired,
    oerTypes: PropTypes.array.isRequired,
    isSaving: PropTypes.bool,
    isSaved: PropTypes.bool,
    updateEmailAlert: PropTypes.func.isRequired
  };

  static defaultProps = {
    isSaving: false,
    isSaved: false
  }

  constructor(props) {
    super(props);
    this.state = {
      oerList: get(this.props.settings, 'eventVideoAlerts', []),
      notificationId: get(this.props.settings, 'notificationId', ''),
      textButton: 'subscribe'
    };
  }

  componentDidMount() {
    const hasEventVideoAlertsSubscription = this.state.notificationId;
    if (hasEventVideoAlertsSubscription) this.updateButtonTitle();
  }

  updateButtonTitle() {
    this.setState({textButton: 'update'});
  }

  handleOerChange = oerSelected => {
    let {oerList} = this.state;
    if (oerList.includes(oerSelected.id)) {
      oerList = oerList.filter(id => {
        return id !== oerSelected.id;
      });
    } else {
      oerList.push(oerSelected.id);
    }
    this.setState({oerList});
  };

  handleSave = () => {
    const {user} = this.props;
    const userData = {
      userId: get(user, 'userInformation.userId', ''),
      email: get(user, 'userInformation.email', '')
    };
    const settings = {eventVideoAlerts: [...this.state.oerList]};
    if (userData.email && userData.userId) {
      this.props.updateEmailAlert(userData, settings);
      this.updateButtonTitle();
    }
  };

  render() {
    const {
      isSaving,
      isSaved,
      oerTypes
    } = this.props;

    const {
      oerList,
      textButton
    } = this.state;

    return (
      <ExpansionPanel defaultExpanded id="panelEmailAlerts">
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h3">{I18n.t('page.userSettings.form.emailAlerts.title')}</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Grid container md={12} xs={12}>
            <Grid item md={12}>
              <div className="admin__checkbox-cont">
                {map(oerTypes, item => {
                  return (
                    <OerCheckBox
                      key={item.id}
                      oer={item}
                      checked={oerList.includes(item.id)}
                      handleChange={this.handleOerChange}
                    />
                  );
                })}
              </div>
            </Grid>
            <Grid item md={12}>
              <div className="admin__info-cont">
                <Icon className="admin__info-icon">info</Icon>{I18n.t('page.userSettings.form.emailAlerts.info')}
              </div>
            </Grid>
            <Grid item md={12}>
              <div className="admin__actions">
                {isSaved && (
                  <div className="feedbackmsg feedbackmsg__success"><Icon className="feedbackmsg__success-icon">done</Icon>{I18n.t('page.userSettings.form.emailAlerts.success')}</div>
                )}
                <Button
                  variant="contained"
                  className="btn btn-primary admin__savebt"
                  onClick={this.handleSave}
                  id="subscribe"
                  disabled={isSaving}
                >
                  {isSaving && (<CircularProgress className="btn__loading btn__loading-primary" />)}
                  {!isSaving && I18n.t(`page.userSettings.form.emailAlerts.button.${textButton}`)}
                </Button>
              </div>
            </Grid>
          </Grid>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}
